<template>
    <DataTable :options="options"
               :params="{ client_id: patient.id }"
               module="patients"
    />
</template>

<script>

import DataTable from "../../parts/general/DataTable"
import options from "../../../data/patients/client_document"
import {mapState} from "vuex"

export default {
  name: "PatientDocuments",
  head() {
    return {
      title: this.$t("documents")
    }
  },
  components: { DataTable },
  data() {
    return {
      options: options
    }
  },
  computed: {
    ...mapState({
      patient:  state => state.patient.patient,
    })
  },
  mounted() {
    this.$store.commit('setEloquentOptions', options)
    if(this.patient) this.$store.commit('setAdditionalParams', {
      client_id: this.patient.id
    })
  },
  beforeUnmount() {
    this.$store.commit('setAdditionalParams', {})
  }
}
</script>
